<!-- @format -->

@if (enrolment.state === "PROCESSING") {
  <div class="processing-state">
    <sis-icon
      [icon]="enrolment.processingState | enrolmentProcessingStateIcon"
      aria-hidden="true"
      [color]="enrolment.processingState === 'REQ_NOT_FULFILLED' ? 'danger' : 'default'"></sis-icon>
    <span>{{ enrolment.processingState | enrolmentProcessingStateMessageKey | translate }}</span>
  </div>
}
